import { AxiosPromise } from 'axios';
import { IQuestionnaireFormValues } from '../form';
import { instance } from '../../../../services';

const createQuestionnaire = (data: IQuestionnaireFormValues): AxiosPromise =>
  instance.post('/api/questionnaires', data);

export default createQuestionnaire;
